import * as Models from '../../models/commonModels';
import * as OrderModels from '../../models/order/order';
import * as OrderNoteModels from '../../models/order/order-note';
import { OrderSearchModel } from '../../models/order/orderSearch';

export class GetOrderStatusDictionary {
  static readonly type = '[Order] GetOrderStatusDictionary';
  constructor(public OrderTypeId: number) { }
  }

export class GetOrderTypeDictionary {
  static readonly type = ' [Order]GetOrderTypeDictionary';
  constructor() { }
  }

export class GetList {
  static readonly type = '[Order] List';
  constructor(public Search: OrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[Order] Set Search';
  constructor(public Search: OrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[Order] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[Order] Set List Page';
  constructor(public Search: OrderSearchModel) { }
}

export class Insert {
  static readonly type = '[Order] Insert';
  constructor(public Order: OrderModels.OrderModel, public Version: number) { }
}

export class Set {
  static readonly type = '[Order] Set';
  constructor(public Order: OrderModels.OrderModel) { }
}

export class Get {
  static readonly type = '[Order] Get';
  constructor(public OrderId: number) { }
}

export class GetReportFiltered {
  static readonly type = '[Order] Report Filtered';
  constructor(public Search: OrderSearchModel) { }
}

export class GetReportNFM {
  static readonly type = '[Order] Report NFM';
  constructor(public Search: OrderSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[Order] DisposeSearch';
  constructor() { }
}


export class SetOrderNote {
  static readonly type = '[Order] Set Order Note';
  constructor(public OrderNote: Models.Request<OrderNoteModels.OrderNoteModel>) { }
}

export class GetOrderNotes {
  static readonly type = '[Order] Get Order Notes';
  constructor(public OrderId: Models.RequestModel) { }
}
